{
  "progression.levelUp.ready": "Ready to level up!",
  "progression.levelUp.button": "Level up",
  "progression.egg.findTitle": "Find a random Suikamon egg!",
  "progression.egg.find": "Find egg",
  "progression.levelUp.title": "LEVEL UP!",
  "progression.levelUp.reached": "{name} reached Level {level}!",
  "progression.levelUp.encourage": "Your pet is getting stronger! Keep taking great care of them!",
  "progression.levelUp.awesome": "Awesome! 🌟",
  "progression.evolve.maxLevel": "Max level reached!",
  "progression.evolve.readyLevel": "Ready to level up to {level}!",
  "progression.evolve.needsXp": "Needs {xp} more XP to level up",
  "progression.egg.unlocksAt": "Egg finding unlocks at level {level}",
  "progression.egg.alreadyFound": "Already found egg at level {level}. Next egg finding at level {next}",
  "progression.egg.ready": "Ready to find an egg! You have a discovery token available",
  "progression.toast.eggDonated": "Egg donated! +{suika} SUIKA added to your Trainer balance",
  "progression.toast.petSold": "Suikamon sold! +{suika} SUIKA added to your Trainer balance",
  "progression.tales.openBook": "Open the Book",
  "progression.tales.continue": "Continue Story",
  "progression.tales.start": "Start Story",
  "progression.tales.bookAriaProgress": "Tale {number}, {name}: {done} of {total} done",
  "progression.tales.bookAriaFinished": "Tale {number}, {name}: finished",
  "progression.tales.bookAriaContinued": "Tale {number}, {name}: to be continued",
  "progression.tales.number": "Tale {number}",
  "progression.tales.toBeContinued": "To be continued",
  "progression.tales.finished": "✓ Finished",
  "progression.tales.shelfTitle": "Gran’s Old Books",
  "progression.tales.allTales": "All Tales",
  "progression.tales.moreSoon": "🔒 More coming soon",
  "progression.tales.lockedAria": "Tale {number}, coming soon",
  "progression.tales.openAria": "Open Tale {number}, {name}",
  "progression.souls.title": "Souls of the Island",
  "progression.souls.count": "{saved}/{total} saved",
  "progression.souls.hint": "One Last Soul waits for every kind of Suikamon. Win its trial and it entrusts you its Soul Shard — tap a soul to travel to its world.",
  "progression.souls.unknown": "Unknown",
  "progression.souls.savedAria": "{name} — soul saved ({world})",
  "progression.souls.waitingAria": "{name} — soul waiting in {world}",
  "progression.souls.lockedAria": "{name} — soul waiting in {world} (locked)",
  "progression.souls.theIsland": "the island",
  "progression.souls.saved": "✨ Saved",
  "progression.souls.shard": "Shard",
  "progression.campaign.loadingTitle": "Loading…",
  "progression.campaign.loadingSubtitle": "Preparing the trail map…",
  "progression.campaign.travelersAria": "Travelers you have met",
  "progression.campaign.entering": "Entering battle…",
  "progression.campaign.taleComplete": "{tale} complete!",
  "progression.campaign.trailLeadsOn": "The trail leads on to {next} — your next story starts here.",
  "progression.campaign.dismiss": "Dismiss",
  "progression.campaign.allTales": "All Tales",
  "progression.campaign.dailyRival": "Rival of the Day: {rival} wants a rematch.",
  "progression.campaign.open": "Open {name}",
  "progression.campaign.fight": "⚔️ Fight {rival}",
  "progression.campaign.completeNext": "{tale} is complete. The trail leads on to {next}.",
  "progression.campaign.completeLast": "{tale} is complete — every page is turned. More books are coming soon.",
  "progression.campaign.continueTo": "Continue to {next}",
  "progression.campaign.watchEnding": "Complete — watch how it ended",
  "progression.rankings.title": "Rankings",
  "progression.rankings.viewPetsAria": "View Suikamons rankings",
  "progression.rankings.pets": "Suikamons",
  "progression.rankings.viewTrainersAria": "View Trainers rankings",
  "progression.rankings.trainers": "Trainers",
  "progression.rankings.filters": "Filters",
  "progression.rankings.activeFilters": "({count} active)",
  "progression.rankings.clearAll": "Clear all",
  "progression.rankings.searchTrainers": "Search Trainers",
  "progression.rankings.searchPlaceholder": "Search trainers…",
  "progression.rankings.loadingPets": "Loading the global pet registry…",
  "progression.rankings.loadingTrainers": "Loading trainer rankings…",
  "progression.rankings.loadingPetsText": "We're syncing with the backend to pull the latest Suikamon roster.",
  "progression.rankings.loadingTrainersText": "We're fetching the latest trainer leaderboard data.",
  "progression.rankings.loadPetsFailed": "Failed to load pets.",
  "progression.rankings.loadTrainersFailed": "Failed to load trainers.",
  "progression.rankings.tryLater": "Please try again later.",
  "progression.rankings.petTotal": "{count, plural, one {There is # pet in the Suikamon World.} other {There are # pets in the Suikamon World.}}",
  "progression.rankings.trainerMatches": "{count, plural, one {Found # trainer matching your search.} other {Found # trainers matching your search.}}",
  "progression.rankings.trainerTop": "Showing top {count} trainers. Use search to find any trainer.",
  "progression.rankings.loading": "Loading…",
  "progression.rankings.loadMore": "Load more",
  "progression.rankings.searchIconAria": "Magnifying glass",
  "progression.rankings.noPets": "No pets found",
  "progression.rankings.noPetsFiltered": "No pets match your current filters. Try adjusting your search criteria.",
  "progression.rankings.noPetsYet": "There are no pets in the registry yet. Be the first to adopt one!",
  "progression.rankings.clearAllFilters": "Clear all filters",
  "progression.rankings.noTrainers": "No trainers found",
  "progression.rankings.noTrainersMatch": "No trainers match your search.",
  "progression.rankings.noTrainersYet": "There are no trainers in the registry yet. Be the first to adopt a pet!",
  "progression.rankings.clearSearch": "Clear search",
  "progression.daily.title": "Daily Rewards",
  "progression.daily.gateTitle": "Free Suika, every day",
  "progression.daily.gateText": "Sign in and open the game each day to grow a ten-day streak that ends on a big Suika reward.",
  "progression.daily.loadFailed": "Could not load your streak.",
  "progression.daily.eyebrow": "Login streak",
  "progression.daily.dayOf": "Day {day} <of>of {lastDay}</of>",
  "progression.daily.collectedAmount": "+{amount} Suika collected",
  "progression.daily.collectedToday": "Collected today",
  "progression.daily.tomorrowPays": "Tomorrow pays {icon} {amount}",
  "progression.daily.claiming": "Claiming…",
  "progression.daily.claim": "Claim {icon} {amount}",
  "progression.daily.caption": "Day {lastDay} pays {amount} Suika. Miss a day and the streak starts over.",
  "progression.gift.ariaAlready": "Gift already opened",
  "progression.gift.ariaOpened": "Gift opened",
  "progression.gift.kickerAlready": "Already Opened",
  "progression.gift.kickerOpened": "Gift Opened",
  "progression.gift.kickerCurrency": "{currency}!",
  "progression.gift.speciesCurrency": "{species} {currency}",
  "progression.gift.converted": "You already have {species}, so they became <b>{icon} {gain}</b>",
  "progression.gift.eggReady": "{species}'s egg is ready to hatch!",
  "progression.gift.eggProgress": "{balance} of {goal} — toward {species}'s egg",
  "progression.gift.sharedWith": "{count, plural, one {Shared with your # Suikamon.} other {Shared with each of your # Suikamon.}}",
  "progression.gift.alreadyHint": "You already collected this gift — it is yours to keep.",
  "progression.gift.thanks": "Thanks!",
  "progression.outcome.ariaWon": "Rival defeated — story",
  "progression.outcome.ariaLost": "Battle lost — story",
  "progression.outcome.kickerWon": "🏆 Rival defeated",
  "progression.outcome.kickerLost": "💀 Battle lost",
  "progression.outcome.soulSaved": "Soul Saved!",
  "progression.outcome.soulRemembered": "Soul Remembered",
  "progression.outcome.soulSafe": "The {species} soul is safe with you",
  "progression.outcome.duplicateSuika": "{icon} {gain} — you already have {species}",
  "progression.outcome.towardSoul": "{icon} +{amount} {species} {currency} — toward recovering its soul",
  "progression.outcome.dailyRivalWon": "⚔️ Rival of the Day — bonus <b>+{xp} XP</b> for each squad member",
  "progression.outcome.dailyRivalTried": "⚔️ Rival of the Day — bonus <b>+{xp} XP</b> for each squad member (for taking the challenge)",
  "progression.outcome.continue": "Continue ▸",
  "progression.map.kind.miniBoss": "MINI-BOSS",
  "progression.map.kind.zoneBoss": "BOSS",
  "progression.map.kind.gift": "GIFT",
  "progression.map.dailyRibbon": "⚔️ Rival of the Day",
  "progression.map.giftAria": "{title} — {name}{claimed, select, yes { (claimed)} other {}}",
  "progression.map.battleAria": "{title} {name}",
  "progression.map.battleAriaSoul": "{title} {name} — {species} soul battle",
  "progression.map.ariaDaily": "{label} — Rival of the Day, fight again today",
  "progression.map.ariaCleared": "{label} (cleared) — read the story, or fight again for no XP",
  "progression.map.storyEyebrow": "Story",
  "progression.map.storyAriaNew": "{title} — a new story to read",
  "progression.map.storyAriaWatch": "{title} — watch the story",
  "progression.map.pagesAhead": "{count, plural, one {# more page ahead} other {# more pages ahead}}",
  "progression.map.pagesCount": "{count, plural, one {+# page} other {+# pages}}",
  "progression.map.chapter": "Chapter",
  "progression.map.chapterNumber": "Chapter {number}",
  "progression.map.dailyWaits": "⚔️ Rival of the Day waits here",
  "progression.map.sealed": "Sealed",
  "progression.map.finished": "✓ Finished · tap to read",
  "progression.map.inProgress": "In progress · tap to open",
  "progression.map.draftAria": "Chapter {number}, still being written",
  "progression.map.draftTitle": "Coming soon",
  "progression.map.draftStatus": "Still being written",
  "progression.map.howItBegan": "How it began",
  "progression.map.howItEnded": "How it ended",
  "progression.daily.popupEyebrow": "Daily reward",
  "progression.daily.popupDay": "Day {day} of {lastDay}",
  "progression.daily.popupHint": "Come back every day — day {lastDay} pays 💧 {amount}. Miss a day and it starts over. Not now? It waits for you on <link>Daily Rewards</link>.",
  "progression.daily.popupClaim": "Claim 💧 {amount}",
  "progression.daily.popupPaid": "💧 {amount} Suika added to your Trainer balance. See you tomorrow!",
  "progression.daily.popupPlay": "Play",
  "progression.giftLink.title": "A gift for you",
  "progression.giftLink.opening": "Opening your gift…",
  "progression.giftLink.goneTitle": "This gift is gone",
  "progression.giftLink.invalid": "This gift link is not valid any more.",
  "progression.giftLink.getFree": "Get a free Suikamon",
  "progression.giftLink.waiting": "{species} is waiting for you",
  "progression.giftLink.rarity": "{rarity} Suikamon",
  "progression.giftLink.meet": "Meet your {species}",
  "progression.giftLink.claim": "Claim {species}",
  "progression.giftLink.signInText": "Sign in, or sign up free, and it's yours.",
  "progression.giftLink.signIn": "Sign in to claim",
  "progression.browse.search": "Search",
  "progression.browse.searchPlaceholder": "Pet name...",
  "progression.browse.species": "Species",
  "progression.browse.allSpecies": "All Species",
  "progression.browse.levelRange": "Level Range",
  "progression.browse.min": "Min",
  "progression.browse.minAria": "Minimum level",
  "progression.browse.to": "to",
  "progression.browse.max": "Max",
  "progression.browse.maxAria": "Maximum level",
  "progression.browse.showHibernated": "Show Hibernated",
  "progression.browse.colName": "Name",
  "progression.browse.colTrophies": "🏆 Trophies",
  "progression.browse.colLevel": "Lvl",
  "progression.browse.colStage": "Stage",
  "progression.browse.colStatus": "Status",
  "progression.browse.hibernated": "Hibernated",
  "progression.browse.active": "Active",
  "progression.seasonBoard.title": "{season} Leaderboard",
  "progression.seasonBoard.loading": "Loading leaderboard...",
  "progression.suikadex.name": "Recovered Souls",
  "progression.suikadex.foundWithDust": "💠 Found with Soul Dust",
  "progression.suikadex.freeStarter": "🌱 Free starter",
  "progression.suikadex.loadFailed": "Could not load {name}",
  "progression.suikadex.opening": "Opening {name}…",
  "progression.suikadex.progressAria": "{name} progress",
  "progression.suikadex.found": "Found",
  "progression.suikadex.foundAria": "{found} of {total} Suikamon found",
  "progression.suikadex.readyCount": "{count} ready to hatch",
  "progression.suikadex.tileFoundAria": "{species}, {rarity}, found",
  "progression.suikadex.tileTrackingAria": "{species}, {rarity}, {have} of {goal} {currency}",
  "progression.suikadex.unknown": "Unknown Suikamon",
  "progression.suikadex.hatch": "Hatch",
  "progression.suikadex.ready": "Ready",
  "progression.suikadex.signUpToHatch": "Sign up to hatch",
  "progression.collection.leftToMint": "Left to mint",
  "progression.collection.maxSupply": "Max supply",
  "progression.collection.minted": "{minted} of {cap} minted",
  "progression.collection.ofAnyRarity": "of any <r>{rarity}</r> Suikamon",
  "progression.rankings.rank": "Rank",
  "progression.rankings.trainer": "Trainer",
  "progression.rankings.eggs": "Eggs",
  "progression.rankings.species": "Species",
  "progression.rankings.cards": "Cards",
  "progression.rankings.pet": "Pet",
  "progression.rankings.level": "Lvl",
  "progression.rankings.final": "Final standings",
  "progression.rankings.seasonPick": "Season:",
  "progression.rankings.empty": "No ranked battles played in this season yet.",
  "progression.podium.title": "🏆 Top Suikamon",
  "progression.podium.aria": "Top 3 Suikamon by trophies",
  "progression.podium.unit": "trophies",
  "progression.podium.seeAll": "See the full rankings",
  "progression.podium.number": "Number {rank}:",
  "progression.trainer.pets": "Suikamons",
  "progression.trainer.level": "Trainer Lvl",
  "progression.trainer.topLevel": "Top Level",
  "progression.trainer.prestige": "{rarity} Trainer",
  "progression.trainer.edit": "Edit profile",
  "progression.trainer.avatarAlt": "Trainer avatar",
  "progression.referral.title": "Invite a friend",
  "progression.referral.terms": "You earn {earn}% · They save {save}%",
  "progression.referral.copied": "Copied!",
  "progression.referral.copyTitle": "Copy referral link",
  "progression.referral.copy": "Copy Link",
  "progression.collection.mine": "My Collection",
  "progression.collection.mineLine": "Discover and collect all Suikamon",
  "progression.collection.found": "Found",
  "progression.collection.notFound": "Not found yet",
  "progression.ladder.aria": "Streak rewards",
  "progression.ladder.dayAria": "Day {day}: {amount} Suika",
  "progression.ladder.dayAriaClaimed": "Day {day}: {amount} Suika, claimed",
  "progression.ladder.day": "Day {day}",
  "progression.chest.rating1": "Modest",
  "progression.chest.rating2": "Decent",
  "progression.chest.rating3": "Good",
  "progression.chest.rating4": "Great",
  "progression.chest.rating5": "Superb",
  "progression.chest.aria": "{rating} reward, {stars} of {max} stars. Tap {remaining, plural, one {# more time} other {# more times}} to open.",
  "progression.chest.tap": "Tap to open!",
  "progression.chest.more": "{remaining} more!",
  "progression.chest.tapsLeft": "{remaining, plural, one {# tap left} other {# taps left}}",
  "progression.chest.opened": "Opened",
  "progression.daily.claimFailed": "Could not claim — please try again.",
  "progression.dailyRival.aria": "Rival of the Day",
  "progression.dailyRival.kicker": "⚔️ Rival of the Day",
  "progression.dailyRival.title": "{title} <b>{name}</b> challenges you to a rematch!",
  "progression.dailyRival.status": "They've been training. One try today: win for a bonus <b>+{xp} XP</b> per squad member.",
  "progression.dailyRival.fight": "Fight!"
}
